import {ParamsModel, StateParamsModel} from 'src/app/modules/common/Model'
import {DeleteGrievanceNatureModel} from '../Model'
import {GrievanceNatureModel} from '../Model/GrievanceNatureModel'
import {actionTypes} from './constants'

export const actions = {
  // get GrievanceNature
  getAllGrievanceNature: () => ({
    type: actionTypes.GET_ALL_GRIEVANCE_NATURE_START,
  }),
  getAllGrievanceNatureSuccess: (data: GrievanceNatureModel) => ({
    type: actionTypes.GET_ALL_GRIEVANCE_NATURE_SUCCESS,
    payload: data,
  }),
  getAllGrievanceNatureFinish: () => ({
    type: actionTypes.GET_ALL_GRIEVANCE_NATURE_FINISH,
  }),

  // get GrievanceNature DATA
  getGrievanceNature: (params: StateParamsModel | {status: number} = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_GRIEVANCE_NATURE_START,
    payload: params,
  }),
  getGrievanceNatureSuccess: (data: GrievanceNatureModel) => ({
    type: actionTypes.GET_GRIEVANCE_NATURE_SUCCESS,
    payload: data,
  }),
  getGrievanceNatureFinish: () => ({
    type: actionTypes.GET_GRIEVANCE_NATURE_FINISH,
  }),

  // create key
  addGrievanceNature: (data: GrievanceNatureModel) => ({
    type: actionTypes.ADD_GRIEVANCE_NATURE_START,
    payload: data,
  }),
  addGrievanceNatureSuccess: (task: any) => ({
    type: actionTypes.ADD_GRIEVANCE_NATURE_SUCCESS,
    payload: task,
  }),
  addGrievanceNatureFinish: () => ({
    type: actionTypes.ADD_GRIEVANCE_NATURE_FINISH,
  }),
  resetGrievanceNature: () => ({
    type: actionTypes.RESET_GRIEVANCE_NATURE,
  }),

  //Update GrievanceNature
  updateGrievanceNature: (data: GrievanceNatureModel, id: string) => ({
    type: actionTypes.UPDATE_GRIEVANCE_NATURE_START,
    payload: data,
    id,
  }),

  updateGrievanceNatureSuccess: (data: GrievanceNatureModel) => ({
    type: actionTypes.UPDATE_GRIEVANCE_NATURE_SUCCESS,
    payload: data,
  }),

  updateGrievanceNatureFinish: () => ({
    type: actionTypes.UPDATE_GRIEVANCE_NATURE_FINISH,
  }),

  // delete key
  deleteGrievanceNature: (data: DeleteGrievanceNatureModel[]) => ({
    type: actionTypes.DELETE_GRIEVANCE_NATURE_START,
    payload: {nature: data},
  }),
  deleteGrievanceNatureSuccess: (data: any) => ({
    type: actionTypes.DELETE_GRIEVANCE_NATURE_SUCCESS,
    payload: data,
  }),
  deleteGrievanceNatureFinish: () => ({
    type: actionTypes.DELETE_GRIEVANCE_NATURE_FINISH,
  }),

  //Enable GrievanceNature
  enableGrievanceNature: (data: any) => ({
    type: actionTypes.ENABLE_GRIEVANCE_NATURE_REQUEST,
    payload: {data},
  }),

  enableGrievanceNatureSuccess: (task: any) => ({
    type: actionTypes.ENABLE_GRIEVANCE_NATURE_SUCCESS,
    payload: task,
  }),
  enableGrievanceNatureFinish: () => ({
    type: actionTypes.ENABLE_GRIEVANCE_NATURE_FINISH,
  }),

  //Disable GrievanceNature
  disableGrievanceNature: (data: any) => ({
    type: actionTypes.DISABLE_GRIEVANCE_NATURE_REQUEST,
    payload: {data},
  }),

  disableGrievanceNatureSuccess: (task: any) => ({
    type: actionTypes.DISABLE_GRIEVANCE_NATURE_SUCCESS,
    payload: task,
  }),
  disableGrievanceNatureFinish: () => ({
    type: actionTypes.DISABLE_GRIEVANCE_NATURE_FINISH,
  }),

  //Enable GrievanceNature
  singleEnableGrievanceNature: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_REQUEST,
    payload: {data},
  }),

  singleEnableGrievanceNatureSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_SUCCESS,
    payload: task,
  }),
  singleEnableGrievanceNatureFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_FINISH,
  }),

  //Disable GrievanceNature
  singleDisableGrievanceNature: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_REQUEST,
    payload: {data},
  }),

  singleDisableGrievanceNatureSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_SUCCESS,
    payload: task,
  }),
  singleDisableGrievanceNatureFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_FINISH,
  }),
}
